const SPAMMER_LABELS = { everyone: 'Everyone' };

export function spammerLabel(id) {
  if (!id) return '';
  return SPAMMER_LABELS[id] ?? 'Unknown';
}
